import React from "react";

/**
 * Última red de seguridad del storefront.
 * Evita que una excepción específica de un navegador deje una pantalla blanca.
 */
export default class StorefrontFatalBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("[storefront] Error fatal de render", {
      error,
      componentStack: info?.componentStack || "",
    });
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <main
        role="alert"
        style={{
          minHeight: "100vh",
          boxSizing: "border-box",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "24px",
          background: "#f7f7f8",
          color: "#17171a",
          fontFamily: "Arial, sans-serif",
        }}
      >
        <div style={{ width: "100%", maxWidth: "520px", textAlign: "center" }}>
          <h1 style={{ margin: 0, fontSize: "24px", lineHeight: 1.2 }}>
            No pudimos terminar de cargar esta página
          </h1>
          <p style={{ margin: "12px 0 0", fontSize: "15px", lineHeight: 1.55, color: "#5f6068" }}>
            Probá recargarla. Si el problema continúa, el sitio seguirá disponible desde otro navegador o dispositivo mientras revisamos esta compatibilidad.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              marginTop: "20px",
              minHeight: "44px",
              padding: "0 20px",
              borderRadius: "10px",
              border: "1px solid #d7d7dc",
              background: "#ffffff",
              color: "#17171a",
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            Recargar página
          </button>
        </div>
      </main>
    );
  }
}
